import { EVisibility } from '@/types/types';

export const VISIBILITY_OPTIONS = [
  {
    label: 'Alta',
    value: EVisibility.ALTA,
  },
  {
    label: 'Media',
    value: EVisibility.MEDIA,
  },
  {
    label: 'Baja',
    value: EVisibility.BAJA,
  },
];
